import * as React from 'react';

export function TokenImage({
  imageSrc,
  symbol,
  secondImageSrc,
}: {
  imageSrc: string;
  symbol: string;
  secondImageSrc?: string;
}) {
  return (
    <div className="inline-block rounded-full p-1 brand-bg">
      <div className="h-20 w-20 bg-darkGray rounded-full relative">
        <img src={imageSrc} alt={symbol} className="h-full rounded-full" />
        {secondImageSrc && (
          <img
            src={secondImageSrc}
            alt="Pair token"
            className="h-9 absolute rounded-full bg-darkGray bg-opacity-90"
            style={{ padding: 4, bottom: 6, right: 6 }}
          />
        )}
      </div>
    </div>
  );
}
